var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_vm._l((_vm.routes), function(item) {
    return [(_vm.check(item)) ? _c('router-link', {
      key: item.path,
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(item.children[0].meta.desc))])], 1)], 1) : _vm._e(), (!item.noDropdown && !item.hidden && _vm.actions.indexOf(item.meta && item.meta.actionId) >= 0) ? _c('el-submenu', {
      key: item.path,
      attrs: {
        "index": item.meta.desc
      }
    }, [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _c('span', [_vm._v(" " + _vm._s(item.meta.desc))])], 1), _vm._l((item.children), function(child) {
      return (!child.hidden && _vm.actions.indexOf(child.meta && child.meta.actionId) >= 0) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        key: child.name,
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        key: child.name,
        staticClass: "menu-indent",
        attrs: {
          "to": ((item.path) + "/" + (child.path))
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v(_vm._s(child.meta.desc))])], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f434cb1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f434cb1","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = oJlG
// module chunks = 1